var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
/**
 * Circular warning marker shown next to a baseline scenario/period/interval whose seat demand
 * exceeds the available inventory. Rendered only by callers that have already determined the
 * exceed condition, so it has no data dependency of its own.
 */
export var SeatExceededIcon = function (_a) {
  var onClick = _a.onClick,
    title = _a.title,
    className = _a.className;
  var t = useTranslation('translation').t;
  var label = title !== null && title !== void 0 ? title : t('seatCapacity.iconTooltip');
  return _jsx(Tooltip, __assign({
    title: label
  }, {
    children: _jsx(Box, __assign({
      component: "span",
      className: className,
      onClick: onClick ? function (e) {
        // Header cells double as sort/expand toggles — don't trigger those when opening the dialog.
        e.stopPropagation();
        onClick();
      } : undefined,
      role: onClick ? 'button' : undefined,
      "aria-label": label,
      sx: {
        color: 'error.main',
        display: 'inline-flex',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default'
      }
    }, {
      children: _jsx(FontAwesomeIcon, {
        icon: faCircleExclamation
      })
    }))
  }));
};